import React from 'react';
import { MobileDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

function DatePicker({ onChange, value, ...props }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileDatePicker
        onChange={dateDayJs => {
          onChange(dateDayJs ? dateDayJs.toDate() : null);
        }}
        value={value ? dayjs(value) : null}
        format="DD/MM/YYYY"
        slotProps={{
          field: {
            readOnly: true
          },
          textField: {
            placeholder: 'DD/MM/YYYY',
            InputLabelProps: { shrink: false },
            sx: {
              '& .MuiInputBase-input': {
                padding: '12px 8px'
              }
            }
          }
        }}
        className="form-control"
        {...props}
      />
    </LocalizationProvider>
  );
}

export default DatePicker;
